import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutYouSteps } from '../../../../../../enums/about-you-steps.enum';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { GettingStartedSteps } from '../../../../../../enums/getting-started-steps.enum';
import { StepSection } from '../../../../../../enums/step-section.enum';
import { PropertySteps } from '../../../../../../enums/property-steps.enum';
import { LoanPurposeOptions } from '../../../getting-started/steps/loan-purpose/loan-purpose.component';

export enum OwnershipOptions {
  Yes = 'Yes',
  No = 'No'
}

@Component({
  selector: 'lgv-borrower-ownership',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule, MatButtonModule
  ],
  templateUrl: './borrower-ownership.component.html',
  styleUrls: ['./borrower-ownership.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BorrowerOwnershipComponent {
  OwnershipOptions = OwnershipOptions
  isDialog = this.contextService.isDialog
  optionSelected = this.answerService.getAnswer(AboutYouSteps.BorrowerOwnership) ?? ''
  isPurchase = this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === 'Purchase' ? true : false
  address = this.answerService.getAnswer(AboutYouSteps.BorrowerCurrentAddress)['Address']

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();

  private yesTasks: string[] = [
    "Mortgage Statement(s)",
    "Homeowner's Insurance",
    "Homeowner's Association statement"
  ];

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService
  ) { }

  ngOnInit(): void {
    this.syncTasksWithAnswer(this.optionSelected);
  }

  onAnswerSelected(ans: string) {
    this.optionSelected = ans
    this.clearAllTasks()
    this.syncTasksWithAnswer(ans)
  }

  onNext() {
    this.answerService.setAnswer(AboutYouSteps.BorrowerOwnership, this.optionSelected)
    this.clearAllTasks();
    this.syncTasksWithAnswer(this.optionSelected);
    this.answerService.getAnswer(AboutYouSteps.BorrowerOwnership) === OwnershipOptions.Yes ? (this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === LoanPurposeOptions.Purchase ?
      this.goToSection(StepSection.Property, PropertySteps.OwnedAddressPlan) : this.goToSection(StepSection.Property, PropertySteps.RefinanceOwnedAddress)) : (this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === LoanPurposeOptions.Purchase ?
        this.goToSection(StepSection.Property, PropertySteps.PreviousOwnership) : this.goToSection(StepSection.Property, PropertySteps.RefinanceSubjectAddress))
  }

  onBack() {
    this.answerService.setAnswer(AboutYouSteps.BorrowerOwnership, this.optionSelected)
    this.clearAllTasks();
    this.goToStep(AboutYouSteps.BorrowerCurrentAddress);
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  isBtnSelected(option: string) {
    if (option === this.optionSelected) {
      return true
    }
  }

  isNextDisabled(): boolean {
    if (this.optionSelected === '') {
      return true
    }
    return false
  }

  private clearAllTasks(): void {
    [...this.yesTasks,]
      .forEach(task => this.taskService.removeTask(task));
  }

  private syncTasksWithAnswer(answer: string): void {
    if (this.isPurchase) {
      switch (answer) {
        case OwnershipOptions.Yes:
          this.yesTasks.forEach(task => this.taskService.addTask(task));
          break;
      }
    }
  }
}
